import { ToastContainer, toast } from "react-toastify";

const validateFileSize = (file, maxSizeMB = 300) => {
  const maxSizeBytes = maxSizeMB * 1024 * 1024;
  if (file && file.size > maxSizeBytes) {
    const notify_message = {
      type: "error",
      message: `File size exceeds ${maxSizeMB} MB limit.`
    };
    notify(notify_message.type, notify_message.message);
    return false;
  }

  return true;
};

const validateMultipleFileSize = (files, maxSizeMB = 300) => {
  const maxSizeBytes = maxSizeMB * 1024 * 1024;
    const fileArray = Array.isArray(files) ? [files] : files;
    
  for (const file of fileArray) {
    if (file.size > maxSizeBytes) {
      const notify_message = {
        type: "error",
        message: `File "${file.name}" exceeds ${maxSizeMB} MB limit.`
      };
      notify(notify_message.type, notify_message.message);
      return false;
    }
  }

  return true;
};

const notify = (type, message) => {
  toast(message, {
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: true,
    closeOnClick: true,
    type: type,
  });
}

export { validateFileSize, validateMultipleFileSize };
